import { defineComponent as _defineComponent } from 'vue'
import {
  getTaskStatusColor,
  getTaskStatusText,
} from '@/utils/status-formatting'
import { formatDurationAsHours } from '@/utils/date-formatting'
import { computed } from 'vue'
import { Duration } from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskStatusChip',
  props: {
    status: null,
    activeDuration: null
  },
  setup(__props: any) {

const props = __props as {
  // props.status should be of type:
  // | TASK_ACTIVE
  // | TASK_CANCELLED
  // | TASK_COMPLETED
  // | TASK_NOT_STARTED
  // | TASK_PAUSED

  // The reason we can't declare this type here is because of Vue <= 3.2 limitation:
  // "In Vue 3.2 and below, the generic type parameter for defineProps() were limited to a type literal or a reference to a local interface."
  // https://vuejs.org/guide/typescript/composition-api#syntax-limitations
  // Once we upgrade to Vue 3.3, we can properly declare the type of props.status
  status: string
  activeDuration?: Duration | null
}

// import {
//   TASK_ACTIVE,
//   TASK_CANCELLED,
//   TASK_COMPLETED,
//   TASK_NOT_STARTED,
//   TASK_PAUSED,
// } from '@/models/unit_number'


const color = computed(() => getTaskStatusColor(props.status))
const label = computed(() =>
  props.activeDuration
    ? formatDurationAsHours(props.activeDuration, true)
    : getTaskStatusText(props.status)
)

return { __sfc: true,props, color, label }
}

})